import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import "../styles/style.css";
import PantryItemOperations from "./pantryitemlistoperations";
import logo from "../images/logo.png";
import RecipeGenerator from "./recipeGenerator";
import PantryCategoryChart from "./pantryChartsForUsers";

function Profile() {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for Firebase Auth session changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const docRef = doc(db, "Users", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserDetails(docSnap.data());
          } else {
            console.log("No user data found");
          }
        } catch (error) {
          console.error("Error fetching user data:", error.message);
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/login");
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
      console.log("User logged out successfully!");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="profile-wrapper">
      {userDetails ? (
        <>
          <nav className="navbar navbar-inverse">
            <div className="container-fluid">
              <div className="navbar-left">
                <img src={logo} alt="Pantry Logo" className="logo" />
                <span className="app-title">PantryPulse</span>
              </div>
              <div className="navbar-header">Welcome: {userDetails.firstName}</div>

              <ul className="nav navbar-nav navbar-right">
                <li>
                  <button className="btn-logout" onClick={handleLogout}>
                    <span className="glyphicon glyphicon-log-in"></span> Logout
                  </button>
                </li>
              </ul>
            </div>
          </nav>

          <div className="main-container">
            <div className="sidebar">
              <button onClick={() => setSelectedComponent("pantry")}>Show Pantry Items</button>
              <button onClick={() => setSelectedComponent("recipes")}>Recipes</button>
              <button onClick={() => setSelectedComponent("chartsForUsers")}>Pantry Insights</button>
            </div>

            <div className="content">
              {selectedComponent === "pantry" && <PantryItemOperations />}
              {selectedComponent === "recipes" && <RecipeGenerator />}
              {selectedComponent === "chartsForUsers" && <PantryCategoryChart />}
            </div>
          </div>
        </>
      ) : (
        <p>No user details available</p>
      )}
    </div>
  );
}

export default Profile;
